export default __webpack_public_path__ + "static/media/nft5.21cb074f.png";